<app-breadcrumb [title]="'Shipping Details'" [breadcrumb]="'Shipping'|translate"></app-breadcrumb>
<!-- <div *ngIf="(shipping$|async) as shipping">
    <pre>
        {{shipping | json}}
    </pre>
</div> -->
<section class="section-b-space" *ngIf="(shipping$ |async) as  shipping">
    <div class="container padding-cls">
        <div class="checkout-page">
            <div class="checkout-form">
                <!-- <div>
                    <pre>
                        {{shipping |json}}
                    </pre>
                </div> -->
                <h4>
                    <a style="cursor: pointer;" (click)="goBack()">{{'Back'|translate }}</a>
                </h4>
                <form>
                    <div class="row">

                        <div class="col-lg-12 col-sm-12 col-xs-12"
                            *ngIf="shipping.imageUrl !='http://localhost:33606/'">
                            <div class="checkout-details">
                                <div class="order-box" style="font-weight: bold;">
                                    <div class="input-group mb-3">


                                        <div class="col-lg-12" *ngIf="shipping.imageUrl !='http://localhost:33606/'">
                                            <div>
                                                <img class="img" style="margin-left: 25%;" [src]="shipping.imageUrl">
                                            </div>
                                        </div>

                                        <!-- 
                                        <div class="col-lg-12">
    
                                            <div class="theme-card">

                                                <div class="form-row" style="margin-top: 20px;">

                                                    <div class="col-md-4">
                                                        <label for="review">Order Date</label>
                                                        <input type="text" readonly style="border-radius: 10px 0px 0px 10px;" [value]="shipping.orderDate | date:'dd-MM-yyyy'" class="form-control" id="color" placeholder="Color">
                                                    </div>


                                                    <div class="col-md-4">
                                                        <label for="review">Confirm Date</label>
                                                        <input type="text" readonly [value]="shipping.confirmDate |date:'dd-MM-yyyy'" class="form-control" id="confirmDate" placeholder="Confirm Date">
                                                    </div>

                                                    <div class="col-md-4">
                                                        <label for="review">Expected Date</label>
                                                        <input type="text" readonly style="border-radius: 0px 10px 10px 0px;" [value]="shipping.expectedDate | date:'dd-MM-yyyy'" class="form-control" id="expectedDate" placeholder="Expected Date">
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 

                                        -->
                                    </div>

                                </div>
                            </div>
                        </div>


                        <div class="col-lg-12 col-sm-12 col-xs-12" style="color: white;">
                            <div class="checkout-details">
                                <!-- List of items -->
                                <div class="order-box" style="font-weight: bold;">
                                    <span style="color: green;">
                                        <i class="fa fa-check-circle" aria-hidden="true"> {{'Request'|translate}} </i>
                                    </span>

                                    <span> <i class="fa fa-arrow-circle-{{isKurdish?'left':'right'}}"
                                            style="margin-left: 10px; margin-right: 10px; " aria-hidden="true"></i>
                                    </span>

                                    <span [ngStyle]="{'color':shipping.shippingStatus>=2?'green':''}">
                                        <i [class]="shipping.shippingStatus>=2?'fa fa-check-circle':'fa fa-circle-thin'"
                                            aria-hidden="true"> {{'Retrun'|translate}}</i>
                                    </span>


                                    <span *ngIf="shipping.shippingStatus ==3"> <i
                                            class="fa fa-arrow-circle-{{isKurdish?'left':'right'}}"
                                            style="margin-left: 10px; margin-right: 10px; " aria-hidden="true"></i>
                                    </span>

                                    <span *ngIf="shipping.shippingStatus ==3"
                                        [ngStyle]="{'color':shipping.shippingStatus ==3?'red':''}">
                                        <i class="fa fa-circle-thin" aria-hidden="true"> {{'Canceled'|translate}}</i>
                                    </span>



                                    <span> <i class="fa fa-arrow-circle-{{isKurdish?'left':'right'}}"
                                            style="margin-left: 10px; margin-right: 10px; " aria-hidden="true"></i>
                                    </span>

                                    <span [ngStyle]="{'color':shipping.shippingStatus>=4?'green':''}">
                                        <i [class]="shipping.shippingStatus>=4?'fa fa-check-circle':'fa fa-circle-thin'"
                                            aria-hidden="true"> {{'Approved'|translate}}</i>
                                    </span>



                                    <span> <i class="fa fa-arrow-circle-{{isKurdish?'left':'right'}}"
                                            style="margin-left: 10px; margin-right: 10px; " aria-hidden="true"></i>
                                    </span>

                                    <span [ngStyle]="{'color':shipping.shippingStatus>=5?'green':''}">
                                        <i [class]="shipping.shippingStatus>=5?'fa fa-check-circle':'fa fa-circle-thin'"
                                            aria-hidden="true"> {{'Purchased'|translate}}</i>
                                    </span>




                                    <span> <i class="fa fa-arrow-circle-{{isKurdish?'left':'right'}}"
                                            style="margin-left: 10px; margin-right: 10px; " aria-hidden="true"></i>
                                    </span>

                                    <span [ngStyle]="{'color':shipping.shippingStatus>=6?'green':''}">
                                        <i [class]="shipping.shippingStatus>=8?'fa fa-check-circle':'fa fa-circle-thin'"
                                            aria-hidden="true">{{'Arrived To Erbil'|translate}}</i>
                                    </span>



                                    <span> <i class="fa fa-arrow-circle-{{isKurdish?'left':'right'}}"
                                            style="margin-left: 10px; margin-right: 10px; " aria-hidden="true"></i>
                                    </span>

                                    <span [ngStyle]="{'color':shipping.shippingStatus>=7?'green':''}">
                                        <i [class]="shipping.shippingStatus>=8?'fa fa-check-circle':'fa fa-circle-thin'"
                                            aria-hidden="true">{{'Sent'|translate}}</i>
                                    </span>



                                    <span> <i class="fa fa-arrow-circle-{{isKurdish?'left':'right'}}"
                                            style="margin-left: 10px; margin-right: 10px; " aria-hidden="true"></i>
                                    </span>

                                    <span [ngStyle]="{'color':shipping.shippingStatus>=8?'green':''}">
                                        <i [class]="shipping.shippingStatus>=9?'fa fa-check-circle':'fa fa-circle-thin'"
                                            aria-hidden="true"> {{'Delivered'|translate}}</i>
                                    </span>




                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-sm-12 col-xs-12">
                            <div class="checkout-details">


                                <!-- List of items -->
                                <div class="order-box">

                                    <!-- <table>
                                        <tbody>
                                            <tr>
                                                <td> Product Name </td>
                                                <td> {{shipping.productName}} </td>
                                            </tr>
                                        </tbody>
                                    </table> -->

                                    <table class="table" style="color:white ;">

                                        <tbody>
                                            <tr>
                                                <th scope="row">1</th>
                                                <td>{{'Order Id'|translate}}</td>
                                                <td>{{shipping.shippingStatus !=1?shipping.shippingId:'-'}}</td>
                                            </tr>

                                            <tr>
                                                <th scope="row">2</th>
                                                <td>{{'Product Name'|translate}}</td>
                                                <td>{{shipping.productName}}</td>
                                            </tr>

                                            <tr>
                                                <th scope="row">3</th>
                                                <td>{{'link'|translate}}</td>
                                                <td>
                                                    <a style="cursor: pointer; text-decoration: underline; color: blue;"
                                                        (click)="openLink(shipping.link)">Link</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">4</th>
                                                <td>{{'Contact By'|translate}}</td>
                                                <td>{{shipping.contactBy?shipping.contactBy:'-'}}</td>
                                            </tr>


                                            <tr>
                                                <th scope="row">5</th>
                                                <td>{{'color'|translate}}</td>
                                                <td>{{shipping.color?shipping.color:'-'}}</td>
                                            </tr>

                                            <tr>
                                                <th scope="row">6</th>
                                                <td>{{'size'|translate }}</td>
                                                <td>{{shipping.size?shipping.size:'-'}}</td>
                                            </tr>


                                            <tr>
                                                <th scope="row">7</th>
                                                <td>{{'Quantity'|translate}}</td>
                                                <td>{{shipping.quantity}}</td>
                                            </tr>

                                            <tr>
                                                <th scope="row">8</th>
                                                <td>{{'Item Price'|translate}}</td>
                                                <td>{{shipping.itemPrice |currency:'USD'}}</td>
                                            </tr>



                                            <tr>
                                                <th scope="row">9</th>
                                                <td>{{'Total US Tax'|translate}}</td>
                                                <td>{{usaTax |currency:'USD'}} </td>
                                            </tr>



                                            <tr>
                                                <th scope="row">10</th>
                                                <td>{{'Local US Shipping'|translate}}</td>
                                                <td>{{shipping.localShippingPrice |currency:'USD'}}
                                                    <span style="color: brown; font-weight: bold;"> (depends on Item)
                                                    </span>
                                                </td>
                                            </tr>


                                            <tr style="font-weight: bold;">
                                                <th scope="row">11</th>
                                                <td>{{'Total Item Price'|translate}}</td>
                                                <td>
                                                    <!-- {{shipping.quantity * (shipping.itemPrice +(shipping.itemPrice * ((shipping.tax>0?shipping.tax:10)/100)) + shipping.localShippingPrice )|currency:'USD'}}</td> -->
                                                    {{(shipping.itemPrice * shipping.quantity) + usaTax +
                                                    shipping.localShippingPrice |currency:'USD'}}
                                                </td>

                                            </tr>

                                            <tr>
                                                <th scope="row">12</th>
                                                <td>{{'Weight'|translate}} </td>
                                                <td>{{shipping.weight}} Lbs</td>
                                            </tr>

                                            <!-- <tr>
                                                <th scope="row">13</th>
                                                <td>{{'Int. Shipping'|translate}}</td>
                                                <td>{{intShipping(shipping.weight) |currency:'USD'}}
                                                    ({{memberShip(membershipType)}} Per Lbs) </td>
                                            </tr> -->

                                            <tr>
                                                <th scope="row">13</th>
                                                <td>{{'Int. Shipping'|translate}}</td>
                                                <td>
                                                    {{shipping.weight * shipping.internationalShippingAmount
                                                    |currency:'USD'}}
                                                    ({{memberShip(membershipType) |currency:'USD'}} per LB) </td>
                                            </tr>




                                            <tr *ngIf="weightByWidthLengthHeight>0">
                                                <th scope="row">13 - </th>
                                                <td>{{'Width * Height * Length'|translate}}</td>
                                                <td>{{weightByWidthLengthHeight |currency:'USD'}} </td>
                                            </tr>


                                            <tr>
                                                <th scope="row">14</th>
                                                <td>{{'Commission'|translate}}</td>
                                                <td>{{shipping.commission|currency:'USD'}}
                                                    <span style="color: brown; font-weight: bold;"> (depends on Item)
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row">15</th>
                                                <td>{{'Express Shipping'|translate}}</td>
                                                <td>{{shipping.expressShipping? (shipping.weight * 1.90
                                                    |currency:'USD')+' ($1.90 per Lbs)':'-'}}</td>
                                            </tr>


                                            <tr>
                                                <th scope="row">16</th>
                                                <td>{{'Insurance'|translate}}</td>
                                                <td>{{shipping.insurance? (2.90 |currency:'USD'):"$0.0"}}</td>
                                            </tr>


                                            <!-- <tr>
                                                <th scope="row">17</th>
                                                <td>{{'Extra Fee'|translate}}</td>
                                                <td>{{shipping.extraFee |currency:'USD'}} <span
                                                        *ngIf="shipping.noteFroExtraFee">{{'-' +
                                                        shipping.noteFroExtraFee}}</span></td>
                                            </tr> -->

                                            <!-- 
                                            <tr>
                                                <th scope="row">18</th>
                                                <td>{{'Note'|translate}}</td>
                                                <td>{{!shipping.note || shipping.note=='null'?'-':shipping.note }}</td>
                                            </tr> -->


                                            <tr *ngIf="shipping.shippingStatus==8">
                                                <th scope="row">19</th>
                                                <td>{{'Box'|translate}}</td>
                                                <td># {{shipping.box}}</td>
                                            </tr>

                                        </tbody>

                                        <tfoot>
                                            <tr>
                                                <th></th>
                                                <th>{{'Sub Total'|translate}}</th>
                                                <th>{{subTotal |currency:'USD'}}</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>{{'Coupon Amount'|translate}} ({{shipping.couponName}}) +
                                                    {{'discount'|translate}}</th>
                                                <th>{{amountDiscountByCoupon |currency:'USD'}}</th>
                                            </tr>


                                            <tr>
                                                <th></th>
                                                <th>{{'Total Price'|translate}}</th>
                                                <th>{{totalPrice |currency:'USD'}}</th>
                                            </tr>




                                            <!-- <tr>
                                                <th scope="row"></th>
                                                <td>{{'Prepaid'|translate}}</td>
                                                <td>{{( shipping.paidAmount) |currency:'USD'}}</td>
                                            </tr>
 -->


                                            <tr>
                                                <th scope="row"></th>
                                                <td>{{'Remain Amount'|translate}}</td>
                                                <td [ngStyle]="{
                                                'color':shipping.shippingStatus !=8?'red':'',
                                            'font-size':shipping.shippingStatus !=8?'20px':''}">
                                                    {{(shipping.shippingStatus==8?0:totalPrice) |currency:'USD'}}</td>
                                            </tr>


                                        </tfoot>
                                    </table>
                                </div>



                                <div class="form-row" *ngIf="shipping.shippingStatus==1">
                                    <div>
                                        <input type="button" style="background: green;" class="btn btn-solid"
                                            value="Confrim Order" (click)="onConfirm(shipping.shippingId ,1)" />
                                    </div>
                                    <div style="margin-left: 20%;">
                                        <input type="button" class="btn btn-solid" value="Cancel Order"
                                            (click)="onConfirm(shipping.shippingId,0)" />
                                    </div>
                                </div>

                            </div>
                        </div>



                    </div>
                </form>
            </div>
        </div>
    </div>
</section>